import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useFeatures, useFetch, useSession, Button } from '@cordata/buffet';
import { useTranslation } from 'react-i18next';
import { capitalize } from 'lodash';
import { Link } from 'react-router-dom';

import {
  RouteTeller,
  PageLayout,
  Navbar,
} from '~/components';

import IdentitySearchCard from '~/components/Patient/Identity/Search/Card';

import PatientsIndex from '~/pages/patients/collection';
import PatientsIndexIdentity from '~/pages/patients/identity/collection';

import { SideNav } from '~/pages/home';

const LeftHand = ({ afterSearch }) => {
  const { current } = useSession();

  const [status, sideNavItems] = useFetch('data/public/list_view_cs_recent_patients', {
    instance: 'p',
    params: {
      page: 1,
      'page-size': 4,
      sort: '-updated-date',
      user_uid: current.attributes.userUid,
    },
  });

  return (
    <>
      <IdentitySearchCard afterSubmit={(x) => afterSearch(x)} />

      {status === 'success' && <SideNav items={sideNavItems} />}
    </>
  );
};

LeftHand.propTypes = {
  afterSearch: PropTypes.func,
};

LeftHand.defaultProps = {
  afterSearch: () => {},
};

const Patients = ({ routes }) => {
  const { hasAppIdentity, ...features } = useFeatures();
  const [t] = useTranslation();

  const [identitySearchParams, setIdentitySearchParams] = useState({});
  const [searchSubmitted, setSearchSubmitted] = useState(false);

  // gross hack to prevent old search page briefly showing in identity
  const didLoadFeatures = JSON.stringify(features) !== '{}';

  const updateIdentitySearch = (params) => {
    setIdentitySearchParams(params);
    setSearchSubmitted(true);
  };

  return didLoadFeatures
    ? (
      <PageLayout
        Header={Navbar}
        Left={hasAppIdentity ? <LeftHand afterSearch={updateIdentitySearch} /> : null}
        centerMain={false}
        title={!hasAppIdentity && capitalize(t('patients'))}
        titleAction={!hasAppIdentity &&
          <Button
            outline
            tag={Link}
            to="/patients/add"
            icon="plus"
          >
            Add {capitalize(t('patient'))}
          </Button>
        }
      >
        <RouteTeller
          exact={hasAppIdentity
            ?
            () => (
              <PatientsIndexIdentity
                searchParams={identitySearchParams}
                searchSubmitted={searchSubmitted}
              />)
            :
            PatientsIndex
          }
          routes={routes}
        />
      </PageLayout>
    )
    : null;
};

Patients.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.shape).isRequired,
};

export default Patients;
